export default {
    loadImg: function (src, cb) {
        var img = new Image();
        img.onload = function (e, src) {
            cb && cb(src)
        };
        img.src = src;
    },
    getImg: function () {
        var _this=this;
        var images = document.querySelectorAll('[_src]');
        var newImages=[]
        Array.prototype.push.apply(newImages,images);
        // console.log(newImages);
        newImages.forEach(function (item){
            var _src = item.getAttribute('_src');
            if (!_src) return;
            var width = item.width;
            var t = Date.now();
            _this.loadImg(_src, function() {
                // console.log('1111', Date.now() - t, _src);
                var src = item.getAttribute('src');
                if (item.tagName === 'IMG') {
                    if (width) {
                        item.setAttribute('src', _src);
                        item.width = width;
                    } else {
                        item.setAttribute('src', _src);
                    }
                    return;
                }
                if (item.style.background !== 'none') {
                    item.style.background = 'url(' + _src + ') no-repeat center';
                    item.style.backgroundSize = 'cover'

                } else {
                    item.children().style.background = 'url(' + _src + ')';
                }
            })
        })
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/utils.js
// module id = null
// module chunks = 